import Vue from 'vue'
import { API_URL } from '@/config'
import router from '@/router'

export const session = {

  namespaced: true,

  state: {
    session: {},
    comments: false,
    changelog: false,
  },

  getters: {
    session: state => state.session,
    comments: state => state.comments,
    changelog: state => state.changelog,
  },

  mutations: {
    setSession(state, session) { state.session = session },
    setComments(state, comments) { state.comments = comments },
    setChangelog(state, changelog) { state.changelog = changelog },
  },

  actions: {

    // getOptions: () => Vue.axios.get(API_URL + '/entities', { params: {
    //   models: ['App\\Models\\Session'],
    //   filter_display: true,
    // }}),

    async getSession({ commit }) {
      const session = await Vue.axios.get(API_URL + '/sessions/' + router.currentRoute.params.id);
      commit('setComments', false);
      commit('setChangelog', false);
      commit('setSession', session.data);
    },

    async sessionSheet({ rootState, commit }, params) {
      if (!rootState.progress) {
        let report = await Vue.axios.get(API_URL + '/report/session/' + params.id, {
          responseType: 'blob',
        });
        commit('setProgress', false, { root: true });
        const href = window.URL.createObjectURL(new Blob([report.data]));
        const link = document.createElement('a');
        link.href = href;
        link.setAttribute('download', 'session-' + params.id + '.pdf');
        document.body.appendChild(link);
        link.click();
      }
    },

    async cloneSession({ commit }) {
      const session_clone = await Vue.axios.post(API_URL + '/sessions/' + router.currentRoute.params.id + '/clone');
      commit('setSession', {});
      router.currentRoute.params.id = session_clone.data;
      if (session_clone.data) router.push('/session/' + session_clone.data + '/edit');
    },

    async toggleSession({ rootState, state, getters, commit }, mode) {
      if (getters.session.day_id && getters.session.start_time && getters.session.end_time && getters.session.room_id) {
        const values = {};
        if (mode === 'program') {
          values.publish = !getters.session.publish;
          values.publish_app = !getters.session.publish;
        }
        if (mode === 'app') {
          values.publish_app = !getters.session.publish_app;
        }
        const session = await Vue.axios.put(API_URL + '/sessions/' + router.currentRoute.params.id, values);
        state.session.publish = session.data.publish;
        state.session.publish_app = session.data.publish_app;
        if (router.currentRoute.path.includes('edit')) {
          rootState.session_edit.values.publish = session.data.publish;
          rootState.session_edit.values.publish_app = session.data.publish_app;
        }
        commit('setProgress', false, { root: true });
        if (mode === 'program') {
          commit('setResponse', { status: true, type: 'success', message: 'session_successfully_' + ((session.data.publish) ? 'published' : 'withdrawn') }, { root: true });
        }
        if (mode === 'app') {
          commit('setResponse', { status: true, type: 'success', message: 'session_successfully_' + ((session.data.publish_app) ? 'published' : 'withdrawn') }, { root: true });
        }
      }
    },

    toggleComments({ state, commit }) {
      commit('setChangelog', false);
      commit('setComments', !state.comments);
    },

    toggleChangelog({ state, commit }) {
      commit('setComments', false);
      commit('setChangelog', !state.changelog);
    },

  }
}
